import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../common/vuex/store'
import VueResource from 'vue-resource'
import VueRaven from 'vue-raven'
import vuexI18n from 'vuex-i18n'
import translationsPl from './i18n/pl'
import translationsEn from './i18n/en'
import translationsUk from './i18n/uk'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit, faAddressBook, faPlusSquare, faSave } from '@fortawesome/free-regular-svg-icons'
import { faCheck, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { VueMaskDirective } from 'v-mask'
import { APP_CONFIG } from './const/config.const'
import { APP_ENV } from '@/common/const/env.const'
import filterPhone from '@/common/filters/phone.filter'
import filterTruncate from '@/common/filters/truncate.filter'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/pl'
import { CookieClass } from '@/common/class/cookie.class'
import { TOPUP_LANG_COOKIE, TOPUP_LANG_COOKIE_EXPIRY, TOPUP_LANG_DEFAULT } from '@/common/const/topup.const'
import { ToolsClass } from '@/common/class/tools.class'
import { LANGS } from '@/common/const/lang.const'
import { BmPrivacyVue } from '@bm/privacy'
import VueForm from '@bm/vue-form'
import VALIDATORS from '@/common/validators'

library.add(faTrashAlt, faEdit, faAddressBook, faSave, faPlusSquare, faSpinner, faCheck)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.directive('mask', VueMaskDirective)

Vue.config.productionTip = false
Vue.use(VueResource)
Vue.use(ElementUI, { locale })
Vue.use(vuexI18n.plugin, store)
Vue.i18n.add('pl', translationsPl)
Vue.i18n.add('en', translationsEn)
Vue.i18n.add('uk', translationsUk)
Vue.use(VueForm, { validators: VALIDATORS })
Vue.use(BmPrivacyVue.default, { env: process.env.NODE_ENV })

const cookieLang = CookieClass.getCookie(TOPUP_LANG_COOKIE)
const currentLang = cookieLang && LANGS.includes(cookieLang) ? cookieLang : TOPUP_LANG_DEFAULT
CookieClass.setCookie(TOPUP_LANG_COOKIE, currentLang, TOPUP_LANG_COOKIE_EXPIRY)
Vue.i18n.set(currentLang)

Vue.filter('phone', filterPhone)
Vue.filter('truncate', filterTruncate)

Vue.prototype.$VUE_APP_OPERATOR = APP_CONFIG.OPERATOR
Vue.prototype.$VUE_APP_CONFIG = APP_CONFIG[process.env.NODE_ENV]

if (process.env.NODE_ENV === APP_ENV.production) {
  Vue.use(VueRaven, {
    dsn: APP_CONFIG[process.env.NODE_ENV].SENTRY,
    environment: process.env.NODE_ENV
  })
}

if (process.env.NODE_ENV === APP_ENV.development && process.env.VUE_APP_USE_MOCK === 'true') {
  const { worker } = require('../mock/browser')
  worker.start()
}

router.beforeEach((to, from, next) => {
  ToolsClass.scrollToTop()
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
